import React, { useState } from "react";
import moment from "moment";

const getMomentFromComponents = (datePart, timePart) => {
  const startDate = moment.utc(datePart).format("YYYY-MM-DD ") + timePart;
  return moment.utc(startDate, "YYYY-MM-DD HH:mm");
}

const AircraftDispatchDeviationsValidator = (props) => {
  const record = props.data.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null
  });

  let error = false;
  let errorMessage = "";

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }


  if (!error && !record.deviationCategory) {
    error = true;
    errorMessage = "'Category' is required";
  }
  if (!error && !record.reportedOn) {
    error = true;
    errorMessage = "'Reported On' is required";
  }
  if (!error && !moment(record.reportedOn).isValid()) {
    error = true;
    errorMessage = "'Reported On' does not contain a valid date";
  }
  if (!error && !record.reportedTime) {
    error = true;
    errorMessage = "Reported 'Time' is required";
  }
  if (record.deviationCategory === "CUSTOM" && !error && !record.details) {
    error = true;
    errorMessage = "'Details' is required for 'Custom' type defects";
  }
  if (!error && record.completedOn && !moment(record.completedOn).isValid()) {
    error = true;
    errorMessage = "'Completed On' does not contain a valid date";
  }

  if (!error) {
    const startMoment = getMomentFromComponents(record.reportedOn, record.startTime);
    const endMoment = getMomentFromComponents(record.completedOn, record.endTime);
    if (endMoment.isBefore(startMoment)) {
      error = true;
      errorMessage = "'Completed On' must be after 'Reported On'";
    }
  }

  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <div style={{display:"none"}}>
      {state.errorMessage}
    </div>
  );
}

export default AircraftDispatchDeviationsValidator;
